import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { Flame, Eye, Play, PhoneIncoming, ChevronRight } from 'lucide-react';

const relTime = (iso) => {
  if (!iso) return '';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 3600) return `${Math.max(1, Math.floor(s / 60))}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

const ord = (n) => (n === 2 ? '2nd' : n === 3 ? '3rd' : `${n}th`);

export const HotDealsWidget = () => {
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    const load = () => api.getHotDeals().then(r => setDeals(r.data.deals || [])).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (deals.length === 0) return null;

  return (
    <div className="bg-orange-500/[0.06] border border-orange-500/30 rounded-sm" data-testid="hot-deals-widget">
      <div className="px-3.5 pt-2.5 pb-1 flex items-center gap-2">
        <Flame className="w-4 h-4 text-orange-400" />
        <span className="text-xs font-medium text-orange-300">Hot deals</span>
        <span className="text-[10px] text-orange-300/60">— fresh scans, plays & responses (48h) plus returning visitors (7d). Call while it's hot.</span>
      </div>
      <div className="px-3.5 pb-3 pt-1 flex gap-2 overflow-x-auto">
        {deals.map(d => (
          <button key={d.project_id} onClick={() => navigate(`/projects/${d.project_id}#section-outreach`)}
            data-testid={`hot-deal-${d.project_id}`}
            className="shrink-0 text-left bg-card/80 border border-orange-500/20 hover:border-orange-500/60 rounded-sm px-3 py-2 transition-colors group">
            <div className="flex items-center gap-1.5">
              <span className="text-xs font-medium text-foreground truncate max-w-[180px]">{d.name}</span>
              <ChevronRight className="w-3 h-3 text-orange-400/0 group-hover:text-orange-400 transition-colors" />
            </div>
            <div className="flex items-center gap-2.5 mt-1 text-[10px] text-muted-foreground">
              {d.scans > 0 && <span className="inline-flex items-center gap-1 text-sky-400"><Eye className="w-3 h-3" />{d.scans}</span>}
              {d.plays > 0 && <span className="inline-flex items-center gap-1 text-sky-400"><Play className="w-3 h-3" />{d.plays}</span>}
              {d.leads > 0 && <span className="inline-flex items-center gap-1 text-emerald-400"><PhoneIncoming className="w-3 h-3" />{d.leads}</span>}
              <span className="font-mono text-muted-foreground/70">{relTime(d.last_activity_at)}</span>
            </div>
            {d.returning && (
              <div className="mt-1 text-[10px] font-medium text-orange-300" data-testid={`hot-deal-returning-${d.project_id}`}>
                <span className="mr-1">{'🔥'.repeat(Math.min(d.returning.visits, 6))}</span>
                {ord(d.returning.visits)} visit{d.returning.gap_days >= 1 ? ` · ${Math.round(d.returning.gap_days)}d after last` : ''}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
